<template>
  <div class="none-data align jus direction" :style="{height: height+'rem'}">
    <img src="../static/images/none-data-2.png" :style="`width: ${imgSize}rem`" alt="">
    <div class="none-title" :style="`font-size: ${fontSize}rem;color:${textColor}`">
      {{propsText||'暂无数据'}}
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      textColor: {
        type:String,
        default:'#A1AEBF'
      },
      height: {
        type: Number
      },
      propsText: String,
      fontSize: {
        type: Number,
        default: 0.28
      },
      imgSize: {
        type: Number,
        default: 1.00
      }
    },
  }
</script>

<style lang='less' scoped>
  .none-data {
    .none-title {
      text-align: center;
      line-height: .54rem;
      margin-top: 0.2rem;
    }
  }
</style>